import { GelProximityPickupError, getElementById } from "./elementUtils";

function displayPickupError(error: string | null = null): void {
  const element = getElementById(GelProximityPickupError);

  if (error) {
    element.innerText = error;
  }

  element.hidden = false;
}

function hidePickupError(): void {
  getElementById(GelProximityPickupError).hidden = true;
}

export { displayPickupError, hidePickupError };
